import React, { useState, useMemo, useEffect } from "react";
// import Toast from "@/utils/toast"; // Removed
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import Layout from "@/components/Layout";
import { API_ENDPOINTS } from "@/config/api";
import api from "@/services/api";

export default function Transfer() {
  const [searchTerm, setSearchTerm] = useState("");

  const [masterPassword, setMasterPassword] = useState("");
  const [transferAmounts, setTransferAmounts] = useState({});
  const [statusMessages, setStatusMessages] = useState({}); // { [id]: { type: 'success'|'error', msg: '' } }

const [agents, setAgents] = useState([]);
const [loading, setLoading] = useState(false);

  const filteredAgents = useMemo(() => {
    if (searchTerm.length < 3) return agents;
    return agents.filter((agent) =>
      agent.loginName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [agents, searchTerm]);


  const handleTransferAll = async () => {
    if (!masterPassword) {
      // Create a specific "Global" error or just alert? 
      // User asked for "text instead red if any error", possibly per row.
      // But for "Please enter Master Password", it applies to all. 
      // I'll set a generic message or alert? 
      // Actually, since "Transfer All" isn't row-specific, maybe we should just set a status on the first visible row or show a global error?
      // Reverting to simple alert or ensuring logic handles per-row if possible.
      // Let's just create errors for ALL visible rows if password missing? No that's spammy.
      // I'll assume for "Transfer All" we might keeping Toast or use a top-level alert?
      // User said "dont use toast".
      // I'll show it in a dedicated global message area or just log it for now as user focus is on row submit. 
      // Actually, let's just use console/alert for global validation for now to avoid toast.
      alert('Please enter Master Password');
      return;
    }

    const transfersToProcess = agents.filter(agent => {
      const amount = transferAmounts[agent.id];
      return amount && parseFloat(amount) > 0;
    });

    if (transfersToProcess.length === 0) {
       alert('No amounts entered for transfer');
       return;
    }

    // Process all transfers
    for (const agent of transfersToProcess) {
       try {
          const payload = {
            userId: agent.dbId,
            amount: parseFloat(transferAmounts[agent.id]),
            recieverType: agent.accountType,
            transactionPassword: masterPassword
          };
          await api.post(API_ENDPOINTS.LORDS.TRANSFER, payload);
          
          setStatusMessages(prev => ({
              ...prev,
              [agent.id]: { type: 'success', msg: 'Successful Balance Transfer' }
          }));
          // Clear amount on success
          setTransferAmounts(prev => ({ ...prev, [agent.id]: '' }));
       } catch (error) {
          let msg = error.response?.data?.message || 'Transfer failed';
          if (msg === 'Insufficient INR balance') msg = 'Insufficient Balance';
          setStatusMessages(prev => ({
              ...prev,
              [agent.id]: { type: 'error', msg: msg }
          }));
       }
    }
    fetchAgents(); // Refresh balances
  };

  const handleTransferAmount = (agentId, amount) => {
    setTransferAmounts((prev) => ({
      ...prev,
      [agentId]: amount,
    }));
  };

  const handleSubmit = async (agentId) => {
    // Clear previous status
    setStatusMessages(prev => ({ ...prev, [agentId]: null }));

    const amount = parseFloat(transferAmounts[agentId]);
    if (isNaN(amount) || amount === 0) {
        setStatusMessages(prev => ({ ...prev, [agentId]: { type: 'error', msg: 'Invalid Amount' } }));
        return;
    }
    
    // Validation based on GT
    const agent = agents.find(a => a.id === agentId);
    if (!agent) return;

    const gt = agent.gt;

    if (gt === 0) {
         setStatusMessages(prev => ({ ...prev, [agentId]: { type: 'error', msg: 'Nothing to clear (GT is already settled)' } }));
         return;
    }

    if (gt < 0) {
        // GT is negative (e.g. -500), need positive amount (0 to 500)
        if (amount <= 0 || amount > -gt) {
             setStatusMessages(prev => ({ ...prev, [agentId]: { type: 'error', msg: `Amount must be between 0 and ${-gt}` } }));
             return;
        }
    } else if (gt > 0) {
        // GT is positive (e.g. 500), need negative amount (-500 to 0)
        if (amount >= 0 || amount < -gt) {
             setStatusMessages(prev => ({ ...prev, [agentId]: { type: 'error', msg: `Amount must be between ${-gt} and 0` } }));
             return;
        }
    }

    if (!masterPassword) {
        setStatusMessages(prev => ({ ...prev, [agentId]: { type: 'error', msg: 'Enter Master Password' } }));
        return;
    }

    try {
        const payload = {
            userId: agent.dbId,
            amount: parseFloat(amount),
            recieverType: agent.accountType,
            transactionPassword: masterPassword
        };

        const response = await api.post(API_ENDPOINTS.LORDS.TRANSFER, payload);
        
        if (response.data.success) {
            setStatusMessages(prev => ({ 
                ...prev, 
                [agentId]: { type: 'success', msg: 'Successful Balance Transfer' } 
            }));
            
            setTransferAmounts(prev => ({ ...prev, [agentId]: '' }));
            fetchAgents(); // Refresh to show new balances
            
            // Clear success message after 3 seconds
            setTimeout(() => {
                setStatusMessages(prev => ({ ...prev, [agentId]: null }));
            }, 3000);
        }
    } catch (error) {
        let msg = error.response?.data?.message || 'Transfer failed';
        if (msg === 'Insufficient INR balance') msg = 'Insufficient Balance';
        setStatusMessages(prev => ({ 
            ...prev, 
            [agentId]: { type: 'error', msg: msg } 
        }));
    }
  };

  const handleAll = (agentId) => {
    const agent = agents.find((a) => a.id === agentId);
    if (agent) {
      handleTransferAmount(agentId, agent.gt * -1);
    }
  };
  const fetchAgents = async () => {
  setLoading(true);
  try {
    const response = await api.get(API_ENDPOINTS.USER.ALL_DETAILS, {
      params: {
        page: 1,
        limit: 100, // enough for transfer screen
        search: searchTerm
      }
    });

    if (response.data?.success && response.data?.data) {
      const { wallets } = response.data.data;

      const mappedAgents = wallets.map(wallet => {
        const rawId = wallet.user_id || wallet.staff_id || wallet.wallet_id;
        const type = wallet.user_type || wallet.role;
        return {
          id: `${type}_${rawId}`, // Unique ID for frontend state
          dbId: rawId,            // Actual DB ID for API
          loginName: wallet.username,
          accountType: type,

          credit: parseFloat(wallet.credit_limit || 0),
          exposure: parseFloat(wallet.exposure || 0),
          availableBalance: parseFloat(wallet.credit || 0),

          gt: parseFloat(wallet.GT || 0),
          status: wallet.status || "ACTIVE",
        };
      });

      setAgents(mappedAgents);
    }
  } catch (err) {
    console.error("Failed to fetch agents for transfer:", err);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  const timer = setTimeout(() => {
    fetchAgents();
  }, 500);

  return () => clearTimeout(timer);
}, [searchTerm]);


  return (
    <Layout>
      <div className="p-4 w-full mx-auto bg-[#171b36] min-h-screen">
        {/* Header Section */}
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
          className="shadow-sm px-4 pt-4"
        >
          <div className="flex justify-between items-start">
            <div className="w-full mb-1">
              <div
                style={{ color: "#cae0e8", fontSize: "24px" }}
                className="font-semibold mb-2"
              >
                Transfer
              </div>
              <div className="w-full h-px bg-white mb-2"></div>
              
              {/* Master Password Section */}
              <div className="flex items-center gap-2 justify-end">
                <label className="text-white text-[14px] font-bold">
                  Master Password:
                </label>
                <input
                  type="password"
                  value={masterPassword}
                  style={{fontSize: '11px', padding: '5px 6px'}}
                  onChange={(e) => setMasterPassword(e.target.value)}
                  placeholder="Master Password"
                  className=" w-[150px]  bg-white text-black placeholder-black rounded-sm border-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                style={{fontSize: '13px', padding: '5px 3px'}}
                  onClick={handleTransferAll}
                  className="bg-[#333d79ff] text-white font-bold  px-2 py-2 transition-colors hover:bg-[#1a4f66]"
                >
                  Transfer All
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
          className="shadow-sm p-4"
        >
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr>
                  <th style={{width: '10%'}} className="text-left px-4 py-2 text-white font-bold text-[15px]">
                    UserName
                  </th>
                  <th style={{width: '13%'}} className="text-left px-4 py-2 text-white font-bold text-[15px]">
                    Account Type
                  </th>
                  <th style={{width: '6%'}} className="text-right px-4 py-2 text-white font-bold text-[15px]">
                    Credit
                  </th>
                  <th style={{width: '10%'}} className="text-right px-4 py-2 text-white font-bold text-[15px]">
                    Exposure
                  </th>
                  <th style={{width: '16%'}} className="text-right px-4 py-2 text-white font-bold text-[15px]">
                    Available Balance
                  </th>
                  <th style={{width: '1%'}} className="text-right px-4 py-2 text-white font-bold text-[15px]">
                    G/T
                  </th>
                  <th className="text-right px-4 py-2 text-white font-bold text-[15px]">
                 
                  </th>
                  <th className="text-center px-4 py-2 text-white font-bold text-[15px]">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredAgents.map((agent, index) => (
                  <tr
                    key={agent.id}
                    className={`transition-colors ${
                      index % 2 === 0 ? "bg-[rgba(245,245,245,0.1)]" : ""
                    }`}
                  >
                    <td  style={{width: '10%'}} className="py-2 px-4 text-white font-medium">
                      {agent.loginName}
                    </td>
                    <td style={{width: '13%'}} className="py-2 px-4 text-white font-bold">
                      {agent.accountType}
                    </td>
                    <td style={{width: '6%'}} className="py-2 px-4 text-right text-white font-bold">
                      {agent.credit.toFixed(2)}
                    </td>
                    <td style={{width: '10%'}} className="py-2 px-4 text-right text-white font-bold">
                      {Math.abs(agent.exposure).toFixed(2)}
                    </td>
                    <td style={{width: '16%'}} className="py-2 px-4 text-right text-white font-bold">
                      {agent.availableBalance.toFixed(2)}
                    </td>
                    <td style={{width: '1%'}} className="py-2 px-4 text-right font-bold text-white">
                      {agent.gt.toFixed(2)}
                    </td>
                    <td className="py-2 px-4">
                      <div className="flex items-center justify-center gap-1">
                        <button
                          onClick={() => handleAll(agent.id)}
                          className="text-[#28a745] text-[12px] font-bold hover:underline"
                        >
                          All
                        </button>
                        <FontAwesomeIcon
                          icon={faArrowRight}
                          className="h-3 w-3 text-[#28a745]"
                        />
                        <input
                          type="number"
                          value={transferAmounts[agent.id] || ''}
                          onChange={(e) => handleTransferAmount(agent.id, e.target.value)}
                          className="w-16 px-2 py-1 text-[12px] bg-white text-black border-none focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                        <button
                          onClick={() => handleSubmit(agent.id)}
                          className="bg-[#333d79ff] text-white text-[12px] font-bold px-3 py-1 transition-colors hover:bg-[#1a4f66]"
                        >
                          Submit
                        </button>
                      </div>
                    </td>
                    <td className="py-2 px-4 whitespace-nowrap">
                       {statusMessages[agent.id] && (
                          <span className={`${statusMessages[agent.id].type === 'success' ? 'text-[#28a745]' : 'text-red-500'} font-bold text-[12px]`}>
                             {statusMessages[agent.id].msg}
                          </span>
                       )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}